<mat-card class="width-gt-xs" data-cy="BootshausPage">
    <mat-card-header>
        <mat-card-title>Unser Bootshaus</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="center"><img src="\assets\img\startseite/haus.jpg" alt="Bootshaus" width="100%" style="max-width: 701px; max-width: 467px;"/></div>
        <article>
            Das Bootshaus liegt direkt an der Fähre Mühlheim - Dörnigheim am Main, und ist der zentrale Treffpunkt der
            PaddlerInnen des KKM. Man kann dort seine Boote lagern, feiern, auf der Terasse sitzen und grillen und
            natürlich auf dem Main paddeln. Zum Bootshaus gehört direkt am Main der Bootssteg und die Anlage für die
            Slalomstangen und Polotore. In der Sommersaison sind diese zum Trainieren dort aufgebaut. Finden ist ganz
            einfach: das Haus mit dem Biber hinter dem Ruderverein.
        </article>
    </mat-card-content>
</mat-card>
